import { Suspense, lazy, useEffect } from "react";

const DashboardApp = lazy(() => import("./DashboardApp"));
const ProductApp = lazy(() => import("./product/ProductApp"));

function shellForPath(pathname: string): "dashboard" | "product" {
  return pathname.startsWith("/app") ? "product" : "dashboard";
}

export default function App() {
  const shell = shellForPath(window.location.pathname);

  useEffect(() => {
    if (shell === "product") {
      document.body.setAttribute("data-foundation-shell", "product");
      document.documentElement.setAttribute("data-foundation-shell", "product");
      return;
    }
    document.body.removeAttribute("data-foundation-shell");
    document.documentElement.removeAttribute("data-foundation-shell");
  }, [shell]);

  return (
    <Suspense
      fallback={
        <div
          style={{
            minHeight: "100%",
            display: "grid",
            placeItems: "center",
            background: shell === "product" ? "linear-gradient(180deg, #f8f3ea 0%, #efe6d6 100%)" : "#000408",
            color: shell === "product" ? "#2b1e13" : "rgba(0, 229, 255, 0.92)",
            fontFamily: shell === "product" ? '"DM Sans", "Avenir Next", sans-serif' : '"Rajdhani", "Share Tech Mono", sans-serif',
          }}
        >
          <div style={{ fontSize: 15, letterSpacing: "0.04em" }}>Loading {shell === "product" ? "Foundation App" : "Mission Control"}…</div>
        </div>
      }
    >
      {shell === "dashboard" ? <DashboardApp /> : <ProductApp />}
    </Suspense>
  );
}
